import api from "./core";

const basePath = "api/core/EpisodeOfCare";

export default {
  get(id) {
    return api.get(`${basePath}/${id}`);
  },
  logEocViewed(id) {
    return api.post(`${basePath}/LogEocViewed/${id}`);
  },
  getPrimaryInsurance(id) {
    return api.get(`${basePath}/${id}/PrimaryInsurance`);
  },
  getSecondaryInsurance(id) {
    return api.get(`${basePath}/${id}/SecondaryInsurance`);
  },
  update(id, data) {
    return api.patch(`${basePath}/${id}`, data);
  },
  updatePrimaryInsurance(id, data) {
    return api.patch(`${basePath}/${id}/PrimaryInsurance`, data);
  },
  updateSecondaryInsurance(id, data) {
    return api.patch(`${basePath}/${id}/SecondaryInsurance`, data);
  },
  deleteSecondaryInsurance(id) {
    return api.delete(`${basePath}/${id}/SecondaryInsurance`);
  },
  delete(id) {
    return api.delete(`${basePath}/${id}`);
  },
  query(filter, extraHeaders = {}) {
    return api.post(`${basePath}/Search`, filter, extraHeaders);
  },
  restore(id, extraHeaders = {}) {
    return api.post(`${basePath}/Restore/${id}`, {}, extraHeaders);
  },
  findAllDeleted(filter, extraHeaders = {}) {
    return api.post(`${basePath}/FindAllDeleted`, filter, extraHeaders);
  },
  queryList(filter, extraHeaders = {}) {
    return api.post(`${basePath}`, filter, extraHeaders);
  },
  getAllEocMinimal(filter, extraHeaders = {}) {
    return api.post(`${basePath}/GetAllEocMinimal`, filter, extraHeaders);
  },
  create(data) {
    return api.put(`${basePath}`, data);
  },
  end(id, data) {
    return api.patch(`${basePath}/${id}/Close`, data);
  },
  reopen(id) {
    return api.patch(`${basePath}/${id}/Reopen`, {});
  },
  getFromClient(clientId) {
    return api.post(`${basePath}/${clientId}`);
  },
  getFromPatientId(patientId) {
    return api.get(`${basePath}/GetFromPatient/${patientId}`);
  },
  getNextEocId(clientId) {
    return api.get(`${basePath}/GetNextEocId/${clientId}`);
  },
  getSummary() {
    return api.get(`${basePath}/Summary`);
  },
  changeStatus(id, newStatus) {
    return api.patch(`${basePath}/${id}/SetStatus/${newStatus}`, {});
  },
  addBadge(eocId, badgeId) {
    return api.put(`${basePath}/AddBadge/${eocId}/${badgeId}`);
  },
  removeBadge(eocId, badgeId) {
    return api.delete(`${basePath}/RemoveBadge/${eocId}/${badgeId}`);
  },
  getAdmissionsMonthSummary() {
    return api.get(`${basePath}/MonthSummary`);
  },
  updateLocation(eocId, locId) {
    return api.patch(`${basePath}/${eocId}/Location/${locId}`, {});
  },
  updateTransferMedicationsToMars(eocId, transferMedicationsToMars) {
    return api.patch(
      `${basePath}/UpdateTransferMedicationsToMars/${eocId}`,
      transferMedicationsToMars,
      {
        "Content-Type": "application/json"
      }
    );
  }
};
